<template>
  <div class="row">
        <div class="col-12" style="
    padding-left: 5px;
    padding-right: 5px;
">
            <div class="card card-style" style="background-color: white; margin-left: 0px; margin-right: 0px;">
               <div class="card-body">
                        <h3 class="card-title">Sobre</h3>
                    <p class="card-text">Este aplicativo tem como objetivo agilizar o atendimento pelas centrais de regulação do
Serviço de Atendimento Móvel SAMU no território brasileiro. 
<br><br>
O aplicativo utiliza as informações cadastradas e os dados de GPS para indicar ao SAMU a
localização do paciente.<br><br>
As centrais de regulação SAMU que utilizam o
SAMU-IT4D recebem automaticamente as
informações previamente cadastradas. Para as demais Cidades que possuem cobertura do SAMU e que não utilizam a solução SAMU-IT4D, o aplicativo realiza somente a ligação para a
Central de Regulação de Urgência e Emergência da região.</p>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    /* changeStatusReceive(object) {
      const self = this;
      const api = self.$store.state.api + "teste";

      self.isLoading = true;

      self.$http
        .post(api, object)
        .then((response) => {})
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    }, */
  },
  components: { Loading },
  props: {},
  mounted: function () {
    $("#menu-main").removeClass("show");
    $(".offcanvas-backdrop.show").removeClass("show");
    /* $(".theme-light").removeAttribute("style","overflow: hidden; padding-right: 0px;"); */
    document.body.setAttribute("style", null);

  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Sobre.vue